<template>
  <overview-section-card v-if="project">
    <v-card-title class="d-flex justify-space-between align-center pb-2">
      <span class="overview-section-title">{{ $t('overview.project') }}</span>
      <v-icon size="small" class="mr-2" @click="toggleEditMode">mdi-pencil</v-icon>
    </v-card-title>
    <v-card-text class="pt-2">
      <v-row>
        <v-col cols="12" sm="6">
          <div class="overview-field" v-if="!editMode">
            <div class="overview-field-label">{{ $t('overview.name') }}</div>
            <div class="overview-field-value">{{ project.name }}</div>
          </div>
          <v-text-field
            v-else
            v-model="editedName"
            :label="$t('overview.name')"
            density="compact"
            variant="outlined"
            class="mb-3"
          ></v-text-field>

          <div class="overview-field" v-if="!editMode">
            <div class="overview-field-label">{{ $t('overview.description') }}</div>
            <div class="overview-field-value">{{ project.description }}</div>
          </div>
          <template v-else>
            <v-text-field
              v-model="editedDescription"
              :label="$t('overview.description')"
              density="compact"
              variant="outlined"
              class="mb-3"
            ></v-text-field>
            <v-btn @click="saveChanges" color="primary">Save</v-btn>
          </template>

          <div class="overview-field">
            <div class="overview-field-label">{{ $t('overview.created_at') }}</div>
            <div class="overview-field-value">{{ formatDate(project.created_at) }}</div>
          </div>
        </v-col>
        <v-col cols="12" sm="6">
          <div class="overview-field">
            <div class="overview-field-label">{{ $t('overview.project_id') }}</div>
            <div class="overview-field-value">{{ project.id }}</div>
          </div>
          <div class="overview-field">
            <div class="overview-field-label">{{ $t('overview.project_owner') }}</div>
            <show-gravatar :user="projectOwner" :small="true"></show-gravatar>
          </div>
          <div class="overview-field">
            <div class="overview-field-label">{{ $t('overview.invite_users') }}</div>
            <div class="avatar-container">
              <show-gravatar
                v-for="user in invitedUsers"
                :key="user.id"
                :user="user"
                :small="true"
              ></show-gravatar>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </overview-section-card>
</template>

<script>
import LoadProjectsMixin from '@/mixins/LoadProjectsMixin';
import LoadUsersMixin from '@/mixins/LoadUsersMixin';
import CurrentUserMixin from '@/mixins/CurrentUserMixin';
import ShowGravatar from '@/components/projects/ShowGravatar.vue';
import OverviewSectionCard from '@/components/overview/OverviewSectionCard.vue';

export default {
  name: 'ProjectDetails',
  mixins: [LoadProjectsMixin, LoadUsersMixin, CurrentUserMixin],
  components: { ShowGravatar, OverviewSectionCard },
  data() {
    return {
      editMode: false,
      editedName: '',
      editedDescription: '',
    };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) {
        return '';
      }
      const dateObject = new Date(dateString);
      const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
      return dateObject.toLocaleDateString('en-US', options);
    },
    toggleEditMode() {
      this.editMode = !this.editMode;
      if (this.editMode) {
        this.editedName = this.project.name;
        this.editedDescription = this.project.description;
      }
    },
    saveChanges() {
      let project = JSON.parse(JSON.stringify(this.project));
      project.name = this.editedName;
      project.description = this.editedDescription;
      this.$store.dispatch('project/patch', { item: project, dispatch: this.$store.dispatch });
    },
  },
  computed: {
    projectOwner() {
      return (
        this.project &&
        this.project.relationships &&
        this.project.relationships.owner &&
        this.project.relationships.owner.username
      )
        ? this.project.relationships.owner
        : 'Unknown';
    },
    invitedUsers() {
      if (!this.users) {
        return '';
      }

      const excludedUsernames = ['admin@box21.ai', 'annotate@box21.ai', 'manager@box21.ai', 'trainer@box21.ai'];

      const filteredUsers = this.users.filter(user => !excludedUsernames.includes(user.email));

      if (this.current_user && this.current_user.id === this.projectOwner.id) {
        const currentUserIndex = filteredUsers.findIndex(user => user.id === this.current_user.id);
        if (currentUserIndex !== -1) {
          filteredUsers.splice(currentUserIndex, 1);
        }
      }

      return filteredUsers;
    },
    project() {
      if (!this.projects) {
        return null;
      }
      let project_id = sessionStorage.getItem('project_id');
      project_id = parseInt(project_id);
      let filtered_project = this.projects.find(project => project.id === project_id);
      return filtered_project || null;
    },
  },
};
</script>

<style scoped>
.avatar-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}

.show-gravatar {
  margin-right: 0;
}
</style>
